import { Combobox, FormField } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useField } from 'formik';
import { countryCodeMapping } from '../../../request/form-view/category-selection/category-view/simple-form-components/phone-input/country-code';

export type CountryCodeComboboxProps = {
    name: string;
    testId: string;
    labelText: string;
    fullCountry?: boolean;
    isMandatory?: boolean;
};

export const CountryCodeCombobox: React.FC<CountryCodeComboboxProps> = ({
    name,
    testId,
    labelText,
    fullCountry,
    isMandatory,
}) => {
    const [field, , helpers] = useField(name);

    const options = Object.entries(countryCodeMapping).map(([countryName, codes]) => ({
        key: countryName,
        value: fullCountry ? countryName : codes[1], // string
    }));

    const selectedOption = options.find((opt) => opt.key === field.value);

    const handleChange = (
        selected: { key: string; value: string | { textValue: string; content: React.ReactNode } }[],
    ) => {
        if (selected && selected.length) {
            helpers.setValue(selected[0].key);
        } else {
            helpers.setValue('');
        }
    };

    return (
        <FormField
            type="select"
            testId="country-code-selection"
            id="country-code-selection"
            labelText={labelText}
            noFloatingLabel
        >
            <Combobox
                name={name}
                testId={testId}
                value={selectedOption ? [selectedOption] : []} // ComboboxOption[]
                onChange={handleChange}
                aria-required={isMandatory}
                options={options}
            />
        </FormField>
    );
};
